import React from 'react';
import { observer } from 'mobx-react';
import { useMutation } from '@apollo/client';

import useSession from 'core/hooks/use-session';
import { useStore } from 'core/store/store.mobx';
import { useToast } from 'core/components/toast';
import { RESET_COMMUNITY_DRIVE_LOGIN } from 'core/store/offer-store/offer-queries';
import Driver from 'common/components/people/driver';
import DriverActions from 'common/components/people/driver-actions';

const PolicyDriver = (props) => {
  const { item } = props;
  const {
    account: {
      policies: { policy: policyStore }
    }
  } = useStore();
  const toast = useToast();
  const [resetDriveLogin] = useMutation(RESET_COMMUNITY_DRIVE_LOGIN);
  const session = useSession();

  const isBix = policyStore.isBix;
  const state = policyStore.geographicState;

  const resetCommunityDriveLogin = (driverId) => {
    resetDriveLogin({
      variables: {
        branchAccountId: String(policyStore?.policy?.id).substring(0, 9),
        driverId
      },
      onCompleted: (data) => {
        if (data.reset) {
          toast.notify({
            type: 'success',
            message: `The Community Driver login has been reset for ${item.firstName} ${item.lastName}`
          });
        }
      }
    });
  };

  const driverSavedOrToggledExcluded =
    policyStore?.segment?.drivers.find((d) => d.id === item.id)?.excludeDriver ?? item.excludeDriver;
  // never allow toggling off an exclusion for a driver on policies
  // https://github.com/gobranch/branch/issues/14526
  const hasPermissionToExcludeDriver = session.canChangeExclusions && !driverSavedOrToggledExcluded;

  return (
    <Driver
      {...props}
      state={state}
      isBix={isBix}
      showCommunityDriveLoginReset
      resetCommunityDriveLogin={resetCommunityDriveLogin}
      actions={
        <DriverActions
          driver={item}
          formikFieldPath={props.fieldName}
          state={state}
          hasPermissionToExcludeDriver={hasPermissionToExcludeDriver}
          {...props}
        />
      }
    />
  );
};

export default observer(PolicyDriver);
